import { getTenancy } from '../hooks/useTenancy';

const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';
const TEST_TENANCY_STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_TEST_TENANCY_STRIPE_PUBLISHABLE_KEY || '';
const STRIPE_ACCOUNT_ID = process.env.REACT_APP_STRIPE_ACCOUNT_ID || '';
const TEST_TENANCY_STRIPE_ACCOUNT_ID = process.env.REACT_APP_TEST_TENANCY_STRIPE_ACCOUNT_ID || '';
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY || '';

/**
 * Returns the appropriate Stripe publishable key based on the current tenancy.
 * In test tenancy, uses the test Stripe key to allow test card numbers.
 * In prod tenancy (or when tenancy is undefined), uses the production key.
 *
 * This mirrors the behavior of FiRecurlyProvider which switches Recurly keys
 * based on tenancy.
 */
export function getStripePublishableKey(): string {
  const tenancy = getTenancy();
  if (tenancy === 'test' && TEST_TENANCY_STRIPE_PUBLISHABLE_KEY) {
    console.debug(`Using test tenancy Stripe publishable key`);
    return TEST_TENANCY_STRIPE_PUBLISHABLE_KEY;
  }
  return STRIPE_PUBLISHABLE_KEY;
}

/**
 * Returns the appropriate Stripe account ID based on the current tenancy.
 * In test tenancy, uses the test/staging Stripe Connect account.
 * In prod tenancy (or when tenancy is undefined), uses the production account.
 *
 * IMPORTANT: Both the publishable key AND account ID must be switched together
 * for test cards to work. Using a test key with a live account will fail with
 * "Your request was in live mode, but used a known test card."
 */
export function getStripeAccountId(): string {
  const tenancy = getTenancy();
  if (tenancy === 'test' && TEST_TENANCY_STRIPE_ACCOUNT_ID) {
    console.debug(`Using test tenancy Stripe account ID`);
    return TEST_TENANCY_STRIPE_ACCOUNT_ID;
  }
  return STRIPE_ACCOUNT_ID;
}

export function getGoogleMapsApiKey(): string {
  return GOOGLE_MAPS_API_KEY;
}
